import {List, Set} from 'immutable';
import {TeamId} from 'records/TeamId';
import {DepartmentId} from 'records/Department';
import TeamListStore from 'stores/TeamListStore';

const MAX_TEAM_FILTER = 30;

/**
 * If we have too many teamIds, fall back to departmentIds instead. Prevents overloading the
 * URL.
 *
 * teamDepartments is populated on StatsPage2 mount, so should be available for all stats queries.
 * @param teamIds
 */
export function resolveMetricTeamFilter(
  teamIds: List<TeamId> | Array<TeamId> | Set<TeamId>
): {departments: Array<DepartmentId>} | {teams: Array<TeamId>} {
  const teams = Array.isArray(teamIds) ? teamIds : teamIds.toJS();

  if (teams.length > MAX_TEAM_FILTER) {
    const teamDepartments = TeamListStore.getState().teamDepartments;
    if (teamDepartments.isEmpty()) {
      console.trace('Trying to fetch metrics without teamDepartments loaded');
    }

    const departments = Set(
      teamIds.map(t => {
        if (teamDepartments.has(t)) {
          return teamDepartments.get(t);
        } else {
          console.error('Couldnt find team in store:', t, teamDepartments);
          return null;
        }
      })
    )
      .remove(null)
      .toJS() as Array<DepartmentId>;
    return {departments};
  } else {
    return {teams};
  }
}
